// extracted by mini-css-extract-plugin
export default {"container":"AddVar-container___5VZxt","title":"AddVar-title___bV0Hq","buttons":"AddVar-buttons___Azmok","button":"AddVar-button___o-ein","input":"AddVar-input___rAiuh"};